module.exports = __webpack_public_path__ + "media/trophy.00ce25b9.svg";